import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAdminContext } from '../../components/self-service/admin/useAdminContext';

// CTV-787: "Payments (Stripe)" is the Payout method tab of Station settings.
// The old URL stays reachable (bookmarks, and a Stripe return trip minted
// against either earlier address) and lands on that tab with its query string
// intact, so ?return=1 and ?stripe_oauth=... still resolve. The Settings
// layout owns the manager gate and the tab owns the flag gate.
const PublisherPaymentsPage: React.FC = () => {
  const ctx = useAdminContext();
  const { search } = useLocation();
  const slug = ctx.mode === 'aggregated' ? ctx.collapseSlug : ctx.slug;
  return <Navigate to={{ pathname: `/admin/${slug}/settings/payout-method`, search }} replace />;
};

export default PublisherPaymentsPage;
